<template>
	<div>
		<v-autocomplete
			solo
			v-model="product"
			:items="productOptions"
			:loading="loadingProducts"
			:search-input.sync="search"
			hide-selected
			hide-details
			item-text="name"
			item-value="id"
			:placeholder="$gettext('Search...')"
			clearable
			return-object
			outlined
			no-filter
			:no-data-text="$gettext('No results found')"
			prepend-inner-icon="search"
		>
			<template slot="item" slot-scope="{ parent, item }">
				<v-col cols="12" md="12" class="pa-0">
					<v-list-item :key="item.id" style @click.capture="clickProduct($event, item)">
						<v-list-item-icon class="mr-3">
							<v-icon color="primary">mdi-spa</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								<template v-if="type === 'supplement'">
									<strong>{{item.name}} | {{item.presentation}} : {{item.volume}} {{item.unit}}</strong>
								</template>
								<template v-if="type === 'formula'">
									<strong>{{item.product.name}}</strong>
								</template>
							</v-list-item-title>
							<!-- <v-list-item-subtitle>{{item.external_entity}}</v-list-item-subtitle> -->
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</template>
		</v-autocomplete>
		<v-dialog v-model="selectedSubstanceQuantityDialog" max-width="40%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Substance Quantity</v-card-title>
				<v-card-text>
					<v-form ref="substanceQuantityForm">
						<v-row no-gutters class="mt-3">
							<v-col cols="6">
								<v-text-field
									:rules="substanceQuantityRules"
									v-model="selectedSubstance.quantity"
									:label="selectedSubstance.product.name"
									class="px-2"
									outlined
									type="number"
								/>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="selectedSubstance.unit"
									:items="availableUnits"
									:label="$gettext('Unit')"
									class="px-2"
									item-text="name"
									item-value="code"
									outlined
									:rules="unitRules"
								></v-select>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="6">
								<v-select
									v-model="selectedSubstance.processing"
									:items="availableProcessing"
									:label="$gettext('Processing')"
									class="px-2"
									item-text="name"
									item-value="id"
									outlined
									return-object
								></v-select>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="selectedSubstance.info"
									:label="$gettext('Info')"
									class="px-2"
									outlined
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="addSubstance">
						<translate>Add</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "SearchSubstances",
	props: ["type", "method", "availableProcessing"],
	data: () => ({
		product: null,
		productOptions: [],
		search: null,
		loadingProducts: false,
		selectedSubstance: {
			product: {},
			quantity: "",
			unit: "g"
		},
		selectedSubstanceQuantityDialog: false,
		availableUnits: [
			{ name: "ug", code: "ug" },
			{ name: "mg", code: "mg" },
			{ name: "g", code: "g" }
		]
	}),
	methods: {
		isInt(n) {
			return Number(n) === n && n % 1 === 0;
		},
		isFloat(n) {
			return Number(n) === n && n % 1 !== 0;
		},
		clickProduct(event, product) {
			if (this.method == "get") {
				event.stopPropagation();
				event.preventDefault();
				this.productOptions = [];
				this.search = null;
				this.$emit("click", product.product.id);
			} else {
				console.log("ADD SUBSTANCE");
				event.stopPropagation();
				event.preventDefault();
				this.selectedSubstance = product;
				this.selectedSubstance.quantity = "";
				this.selectedSubstance.unit = "";
				this.selectedSubstanceQuantityDialog = true;
				setTimeout(() => {this.$refs.substanceQuantityForm.reset()});
			}
		},
		addSubstance() {
			if (this.validateSubstanceQuantity()) {
				this.$emit("add-product", this.selectedSubstance);
				this.selectedSubstanceQuantityDialog = false;
			}
		},
		validateSubstanceQuantity() {
			return this.$refs.substanceQuantityForm.validate();
		},
		makeRequest() {
			clearTimeout(this._timerId);
			if (this.search) {
				this._timerId = setTimeout(() => {
					console.log("API CALL");
					this.loadingProducts = true;
					var link = "";
					var context = "";
					if (this.type === "supplement") {
						link = "/products/list";
						context = "new-product";
					} else {
						link = "/mtc/substances";
						context = "new-formula";
					}
					axios
						.get(link, {
							params: {
								context: context,
								keyword: this.search.toLowerCase()
							}
						})
						.then(response => {
							console.log(response.data);
							this.productOptions = response.data;
							this.loadingProducts = false;
						})
						.catch(error => {
							console.log(error);
							this.loadingProducts = false;
						});
				}, 300);
			}
		}
	},
	computed: {
		unitRules() {
			return [v => !!v || this.$gettext("Required")];
		},
		substanceQuantityRules() {
			return [
				v => !!v || this.$gettext("Required"),
				v =>
					!(this.isInt(v) || this.isFloat(v)) ||
					this.$gettext("Invalid quantity")
			];
		}
	},
	watch: {
		search() {
			this.productOptions = [];
			this.makeRequest();
		}
	}
};
</script>